import { render } from "./EmployeeDeniedServiceReports.vue?vue&type=template&id=58146588"
import script from "./EmployeeDeniedServiceReports.vue?vue&type=script&lang=js"
export * from "./EmployeeDeniedServiceReports.vue?vue&type=script&lang=js"

import "./EmployeeDeniedServiceReports.vue?vue&type=style&index=0&id=58146588&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__